import { LANGUAGES, REGIONS } from 'state/intl/types';

export const regionSupportedLanguages = {
  [REGIONS.US]: new Set([LANGUAGES.en]),
  [REGIONS.CH]: new Set([LANGUAGES.en, LANGUAGES.de]),
  [REGIONS.CA]: new Set([LANGUAGES.fr, LANGUAGES.en]),
  [REGIONS.ES]: new Set([LANGUAGES.es, LANGUAGES.ca, LANGUAGES.gl, LANGUAGES.eu, LANGUAGES.en]),
  [REGIONS.PT]: new Set([LANGUAGES.pt, LANGUAGES.en]),
};
